/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.30.0
 */

import { EBasketType } from '@/main/modules/app/appConstants';
import { EBreadCrumbType } from '@/main/modules/breadCrumbs/breadCrumbsTypes';

import { IWizardRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export const WizardCollationReportRouteConfiguration: IWizardRouterConfiguration[] = [
    {
        basketType: EBasketType.ACCOUNT,
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.wizardCollationReport],
        path: RoutePath.wizardCollationReportFromAccounts,
    },
    {
        basketType: EBasketType.ACCOUNT,
        breadCrumbs: [EBreadCrumbType.accounts, EBreadCrumbType.accountId, EBreadCrumbType.wizardCollationReport],
        path: RoutePath.wizardCollationReportFromAccountId,
    },
];
